import { PageData } from '../../../../_metronic/helpers/utils/types';

export const faqData: PageData = [
  {
    formId: 'form1',
    heading: 'FAQ Section',
    data: [
      { id: 'metaName', label: 'Meta title', type: 'input' },
      { id: 'metaContent', label: 'Meta description', type: 'input' },
      { id: 'title', label: 'Title', type: 'input' },
      { id: 'subtitle', label: 'Subtitle', type: 'input' },
      { id: 'content', label: 'Content', type: 'textarea' }
    ]
  },
  {
    formId: 'formGroup1',
    heading: 'FAQ: Questions and Answers',
    data: [
      { id: 'question', label: 'Question', type: 'textarea' },
      { id: 'answer', label: 'Answer', type: 'textarea' }
    ]
  }
];
